import React from 'react'
import { Button } from '@mui/material'
import Frame from '../Frame'
import DateOutlinedInput from '../../input/DateOutlinedInput'
import CustomOutlinedInput from '../../input/CustomOutlinedInput'
import CustomCheckbox from '../../input/CustomCheckbox'
import SearchIcon from '@mui/icons-material/Search'
import LayersClearIcon from '@mui/icons-material/LayersClear'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import FileUploadIcon from '@mui/icons-material/FileUpload'

const MastaSearchForm = ({ 
        id, value, handleChange, handleSearch, handleSearchClear, handleClickNew, excelRef, handleExcelOnchange, handleExcelClick
    }) => {
    return (
        <div style={{display:'flex'}}>
            <div style={{marginLeft:'5px'}}>
                <CustomOutlinedInput type="text" id={ id } value={ value } label="コード・名称を入力して検索" width="500px" onChange={handleChange} />
            </div>
            <div style={{marginLeft:'20px'}}>
                <Button
                    color   = "secondary"
                    style   = {{color:'#fff'}}
                    size    = "midium"
                    variant = "contained"
                    onClick = { handleSearch }
                    startIcon={<SearchIcon />}
                    sx ={{paddingLeft:'30px'}}
                >
                </Button>
            </div>
            <div style={{marginLeft:'20px'}}>
                <Button
                    color   = "secondary"
                    style   = {{color:'#fff'}}
                    size    = "midium"
                    variant = "contained"
                    onClick = { handleSearchClear }
                    startIcon={<LayersClearIcon />}
                    sx ={{paddingLeft:'30px'}}
                >
                </Button>
            </div>
            <div style={{marginLeft:'20px'}}>
                <Button
                    color   = "primary"
                    style   = {{color:'#fff'}}
                    size    = "midium"
                    variant = "contained"
                    startIcon={<AddCircleIcon />}
                    onClick = { handleClickNew }
                >
                新　規
                </Button>
            </div>
            <div style={{marginLeft:'10px'}}>
                <input type="file" ref={ excelRef } accept=".xlsx,.xls" onChange={ handleExcelOnchange } style={{ display: 'none' }}/>
                <Button
                    color   = "primary"
                    style   = {{color:'#fff'}}
                    size    = "midium"
                    variant = "contained"
                    startIcon={<FileUploadIcon />}
                    onClick = { handleExcelClick }
                >
                EXCEL
                </Button>
            </div>
        </div>
    );
}

export default MastaSearchForm